const KEY = "plannio_theme";

// Returns the OS-level preference.
export function systemPrefersDark() {
  return window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches;
}

// The stored preference: "light" | "dark" | "system" (defaults to "system").
export function getThemePref() {
  const v = localStorage.getItem(KEY);
  return v === "light" || v === "dark" || v === "system" ? v : "system";
}

// Whether dark should currently be applied, given a preference.
export function resolveDark(pref = getThemePref()) {
  return pref === "dark" || (pref === "system" && systemPrefersDark());
}

function paint(dark) {
  document.documentElement.classList.toggle("dark", dark);
}

// Apply and persist a preference. pref: "light" | "dark" | "system".
export function applyTheme(pref) {
  const p = pref === "light" || pref === "dark" || pref === "system" ? pref : "system";
  localStorage.setItem(KEY, p);
  paint(resolveDark(p));
}

let systemListenerBound = false;

// Call once at startup: paint the stored preference and keep "system" live.
export function initTheme() {
  paint(resolveDark());
  if (!systemListenerBound && window.matchMedia) {
    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    const onChange = () => { if (getThemePref() === "system") paint(resolveDark("system")); };
    if (mq.addEventListener) mq.addEventListener("change", onChange);
    else if (mq.addListener) mq.addListener(onChange);
    systemListenerBound = true;
  }
}
